var _path, _rect, _line, _circle, _path2, _circle2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootdeskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pitchGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22C55E",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#15803D",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 80 Q100 50 130 50 L370 50 Q400 50 400 80 L400 280 Q400 310 370 310 L160 310 L100 370 Z",
    fill: "url(#pitchGrad)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 80,
    width: 240,
    height: 200,
    rx: 5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    opacity: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 180,
    x2: 370,
    y2: 180,
    stroke: "#FFFFFF",
    strokeWidth: 4,
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 180,
    r: 40,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 130 C280 130 330 180 330 180 C330 180 280 230 220 230",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 180,
    r: 25,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 440,
    fontFamily: "Arial, sans-serif",
    fontWeight: 900,
    fontSize: 64,
    fill: "#ffffffff",
    textAnchor: "middle",
    letterSpacing: -2
  }, "FOOTDESK")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 475,
    fontFamily: "Arial, sans-serif",
    fontWeight: 500,
    fontSize: 18,
    fill: "#4B5563",
    textAnchor: "middle",
    letterSpacing: 4
  }, "TEAM COMMUNICATION")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootdeskLogo);
export default __webpack_public_path__ + "static/media/footdesk-logo.6fa0d896b2f0f9ecb6127e4205dbdca3.svg";
export { ForwardRef as ReactComponent };